import Section from "components/layout/section"
import SectionHeader from "components/layout/sectionHeader"
import SectionHeaderTitle from "components/layout/sectionHeaderTitle"
import { TFunction } from "i18next"
import { useTranslation } from "react-i18next"
import PageTitle from "features/navigation/pageTitle"
import RightSidebar from "@/components/sidebar/right/RightSidebar"
import Hint from "@/components/text/Hint"
import LegalLinks from "@/components/legal/LegalLinks"
import { useHideMainSheet } from "@/components/layout/layoutChrome"

type LegalDoc = "privacy" | "terms"

type LegalSection = {
    title: string
    paragraphs: string[]
}

const asSections = (t: TFunction, key: string): LegalSection[] => {
    const value = t(key, { returnObjects: true })
    if (!Array.isArray(value)) return []
    return value.filter((section): section is LegalSection => {
        if (!section || typeof section !== "object") return false
        const candidate = section as LegalSection
        return typeof candidate.title === "string" && Array.isArray(candidate.paragraphs)
    })
}

const LegalPage = ({ doc }: { doc: LegalDoc }) => {
    const { t } = useTranslation()
    useHideMainSheet()

    const title = t(doc === "privacy" ? "titlePrivacy" : "titleTerms")
    const intro = t(doc === "privacy" ? "privacyIntro" : "termsIntro")
    const sections = asSections(t, doc === "privacy" ? "privacySections" : "termsSections")

    return (
        <>
            <PageTitle title={title} />
            <Section design="panel">
                <SectionHeader>
                    <SectionHeaderTitle>
                        <h1 className="whitespace-normal">{title}</h1>
                    </SectionHeaderTitle>
                </SectionHeader>
                <Hint>{t("legalDraftNotice")}</Hint>
                <p>{t("legalLastUpdated")}</p>
                <p>{intro}</p>
                {sections.map((section) => (
                    <div key={section.title} className="flex flex-col gap-y-2">
                        <h2 className="whitespace-normal">{section.title}</h2>
                        {section.paragraphs.map((paragraph) => (
                            <p key={paragraph}>{paragraph}</p>
                        ))}
                    </div>
                ))}
                <LegalLinks />
            </Section>
            <RightSidebar />
        </>
    )
}

export default LegalPage
